import React, { useContext, useMemo } from 'react';
import { FlowContent } from '../../constants/Flows';
import StepConfirmation from './Steps/StepConfirmation';
import { useOnboarding } from 'src/features/onboarding/hooks.tsx/use-onboarding';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useSiteimprove from 'src/hooks/use-siteimprove';
import { SideMenuSubpageContext } from '../../constants/Context';
import { SITEIMPROVE_DECLARATIONS } from 'src/features/tracking/constants';
import { Alert, CardNavigation, Heading, Spinner, Tag } from '@innovationnorway/cl-react';

export const GuidedTourWrapper = () => {
  const { setPage, flow, setFlow } = useContext(SideMenuSubpageContext);
  const { t: tCommon } = useTranslation();
  const { t: tOnboarding } = useTranslation('onboarding');
  const siteimprove = useSiteimprove();

  const { onboardingPackets, completeOnboardingPacket, onboardingQuery } = useOnboarding();

  const handleComplete = useMemo(() => {
    return () => {
      if (flow) {
        completeOnboardingPacket(flow.id).then(() =>
          siteimprove.log(SITEIMPROVE_DECLARATIONS.ONBOARDING.id, flow.code, 'Complete'),
        );
      }
      if (setFlow) {
        setFlow(null);
      }
    };
  }, [completeOnboardingPacket, flow, setFlow, siteimprove]);

  if (!setPage) return <></>;

  if (onboardingQuery.isLoading) return <Spinner aria-label={tCommon('loading')} />;

  if (flow) {
    return (
      <StepConfirmation
        pages={FlowContent[flow.code]}
        name={flow.name || ''}
        code={flow.code || ''}
        flowCompleted={flow.completed}
        completeOnboardingPacket={handleComplete}
      ></StepConfirmation>
    );
  }

  return (
    <>
      <Heading level={2} className="help-and-support__header">
        {tOnboarding('helpAndSupport.tab.Startup')}
      </Heading>
      <Alert data-color="warning" className="margin-bottom--2">
        {tOnboarding('guide.warning')}
      </Alert>
      <div>
        {onboardingPackets.map((packet) => (
          <div key={packet.id + 'Selection'} className="margin-bottom--2">
            <CardNavigation>
              {packet.completed && (
                <CardNavigation.Header>
                  <Tag data-color={'success' as const}>{tCommon('completed')}</Tag>
                </CardNavigation.Header>
              )}
              <CardNavigation.Title as="h3">
                <CardNavigation.Anchor asChild>
                  <Link to={FlowContent[packet.code][0].pageUrl} onClick={() => setFlow && setFlow(packet)}>
                    {packet.name || tOnboarding('guide.Overview.Heading')}
                  </Link>
                </CardNavigation.Anchor>
              </CardNavigation.Title>
              {packet.description && (
                <CardNavigation.Description>{packet.description}</CardNavigation.Description>
              )}
            </CardNavigation>
          </div>
        ))}
      </div>
    </>
  );
};
